import { RouterModule } from '@angular/router'
import { AnalyticsMapComponent } from './analytics-map.component'
import { CommonModule } from '@angular/common'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { NgModule } from '@angular/core'
import { TranslateModule } from '@ngx-translate/core'
import { MapCoordinatesFinderModule } from '@components/map-coordinates-finder/map-coordinates-finder.module'
import { LottieComponent } from 'ngx-lottie'

@NgModule({
  declarations: [AnalyticsMapComponent],
  imports: [
    CommonModule,
    BrowserAnimationsModule,
    RouterModule,
    TranslateModule,
    MapCoordinatesFinderModule,
    LottieComponent,
  ],
  exports: [AnalyticsMapComponent],
})
export class AnalyticsMapModule {}
